import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ExamCompassContext } from '../Context/context';
import { IoEyeOffOutline } from 'react-icons/io5';
import { IoEyeOutline } from 'react-icons/io5';

// svg
import registerImg from '../Assets/register.svg';
import logo2 from '../Assets/compass-logo-2.svg';
import person from '../Assets/person.svg';
import dottedLine from '../Assets/dotted.svg';
import SuccessOne from './SuccessOne';

type RegisterPropsType = {
  setCurrentPage: React.Dispatch<React.SetStateAction<string>>;
  showPassword: boolean;
  setShowPassword: React.Dispatch<React.SetStateAction<boolean>>;
};

const Register: React.FC<RegisterPropsType> = ({
  setCurrentPage,
  showPassword,
  setShowPassword,
}) => {
  // From comtext
  const {
    registerFields,
    handleRegistrationInput,
    error,
    regNonFieldError,
    registerUser,
    fieldErrors,
    registrationSuccessful,
    states,
    loading,
    loginError,
    setLoginError,
  } = useContext(ExamCompassContext);
  const [showConfirmPassword, setShowConfirmPassword] =
    useState<boolean>(false);

  useEffect(() => {
    if (setLoginError) {
      setTimeout(() => {
        if (loginError !== null) {
          setLoginError(null);
        }
      }, 2000);
    }
  }, [setLoginError, loginError]);
  console.log('reg_non_field_error', regNonFieldError);
  console.log('_field_error____', fieldErrors);
  return (
    <>
      {registrationSuccessful && <SuccessOne />}
      <section className=' overflow-hidden'>
        <div className=' flex lg:p-0 h-[100vh]'>
          <div className='w-full lg:w-[70%] p-4 bg-white overflow-y-scroll register-scroll'>
            <div className='flex items-center justify-between mb-8 px-3 lg:w-[90%]'>
              <Link to={'/'}>
                <img src={logo2} alt='ExamCompass' className='w-[50px]' />
              </Link>
              <Link to={'/login'}>
                <div className='flex items-center gap-1'>
                  <p className='text-darkGreen text-[0.825em] cursor-pointer'>
                    Already Registered?
                  </p>
                  <img src={person} alt='Placeholder' /> Login
                </div>
              </Link>
            </div>
            <div className='w-full md:h-auto  lg:w-[87%] mx-auto form-scroll lg:pr-9'>
              <div className='flex items-center justify-between mb-5'>
                <h1 className='text-[23px] md:text-[2em] text-darkGreen font-bold'>
                  Input your <br />
                  information
                </h1>
                <p className='hidden md:block md:w-[300px] text-[0.825em] text-darkGreen leading-[22px]'>
                  We need you to help us with some basic information for your
                  account creation. Here are our{' '}
                  <Link
                    to={'/terms-and-conditions'}
                    onClick={() => setCurrentPage('terms')}
                    className='font-semibold'
                  >
                    terms and conditions
                  </Link>
                  . Please read them carefully.
                </p>
              </div>

              <img src={dottedLine} alt='Line' className='w-full mb-8' />
              <span className='text-red-500'>{loginError}</span>
              <form className='w-full' onSubmit={registerUser}>
                <h1 className='text-2xl text-darkGreen font-bold'>
                  {regNonFieldError}
                </h1>
                <div className='md:flex w-full items-center md:gap-8 md:mb-2'>
                  <div className='mb-2 md:w-[50%]'>
                    <div className='flex items-center justify-between mb-1'>
                      <p className='text-darkText text-[0.825em]'>Username</p>
                      {fieldErrors?.username && (
                        <p className='text-red-700 text-[14px]'>
                          {fieldErrors?.username[0]}
                        </p>
                      )}
                    </div>
                    <input
                      type='text'
                      placeholder='@user3251'
                      name='userName'
                      value={registerFields?.userName}
                      onChange={handleRegistrationInput}
                      className='w-full p-2 border border-slate-300 text-[0.825em] outline-none'
                    />
                  </div>

                  <div className='mb-2 md:w-[50%]'>
                    <div className='flex items-center justify-between mb-1'>
                      <p className='text-darkText text-[0.825em]'>Email</p>
                      {fieldErrors?.email && (
                        <p className='text-red-700 text-[14px]'>
                          {fieldErrors?.email?.[0]}
                        </p>
                      )}
                    </div>
                    <input
                      type='email'
                      placeholder='example@gmail.com'
                      name='email'
                      value={registerFields?.email}
                      onChange={handleRegistrationInput}
                      className='w-full p-2 border border-slate-300 text-[0.825em] outline-none'
                    />
                  </div>
                </div>

                <div className='md:flex w-full items-center md:gap-8 mb-3'>
                  <div className='mb-2 md:w-[50%]'>
                    <div className='flex items-center justify-between mb-1'>
                      <p className='text-darkText text-[0.825em]'>Passsword</p>
                      {fieldErrors?.password && (
                        <p className='text-red-700 text-[14px]'>
                          {fieldErrors?.password?.[0]}
                        </p>
                      )}
                    </div>
                    <div className=' border border-slate-300 flex items-center gap-4 px-2'>
                      <input
                        type={showPassword ? 'text' : 'password'}
                        name='password'
                        value={registerFields?.password}
                        onChange={handleRegistrationInput}
                        className='w-full py-2 text-[0.825em] outline-none'
                      />
                      {showPassword ? (
                        <IoEyeOutline
                          size={20}
                          onClick={() => setShowPassword(false)}
                          className='text-slate-500 cursor-pointer'
                        />
                      ) : (
                        <IoEyeOffOutline
                          onClick={() => setShowPassword(true)}
                          size={20}
                          className='text-slate-500 cursor-pointer'
                        />
                      )}
                    </div>
                  </div>

                  <div className='mb-2 md:w-[50%]'>
                    <div className='flex items-center justify-between mb-1'>
                      <p className='text-darkText text-[0.825em]'>
                        Confirm Password
                      </p>
                      {error && (
                        <p className='text-red-700 text-[14px]'>
                          {error.confirmPassword}
                        </p>
                      )}
                    </div>
                    <div className=' border border-slate-300 flex items-center gap-4 px-2'>
                      <input
                        type={showConfirmPassword ? 'text' : 'password'}
                        name='confirmPassword'
                        value={registerFields?.confirmPassword}
                        onChange={handleRegistrationInput}
                        className='w-full py-2 text-[0.825em] outline-none'
                      />
                      {showConfirmPassword ? (
                        <IoEyeOutline
                          size={20}
                          onClick={() => setShowConfirmPassword(false)}
                          className='text-slate-500 cursor-pointer'
                        />
                      ) : (
                        <IoEyeOffOutline
                          onClick={() => setShowConfirmPassword(true)}
                          size={20}
                          className='text-slate-500 cursor-pointer'
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className='md:flex w-full items-center md:gap-8 mb-3'>
                  <div className='md:w-[50%] mb-2'>
                    <div className='flex items-center justify-between mb-1 w-[50%]'>
                      <p className='text-darkText text-[0.825em]'>
                        Referral Code
                      </p>
                    </div>
                    <input
                      type='text'
                      placeholder='25FA'
                      name='referralCode'
                      value={registerFields?.referralCode}
                      onChange={handleRegistrationInput}
                      className='w-[50%] p-2 border border-slate-300 text-[0.825em] outline-none'
                    />
                  </div>

                  <div className='mb-2 md:w-[50%]'>
                    <div className='flex items-center justify-between mb-1'>
                      <p className='text-darkText text-[0.825em]'>
                        Phone number
                      </p>
                      {fieldErrors?.profile?.phone_number && (
                        <p className='text-red-700 text-[14px]'>
                          {fieldErrors?.profile?.phone_number?.[0]}
                        </p>
                      )}
                    </div>
                    <div className='flex'>
                      <span className='flex items-center justify-center px-2 border border-r-0 border-slate-300 bg-slate-100 text-[0.825em]'>
                        +234
                      </span>
                      <input
                        type='tel'
                        placeholder='7000000000'
                        name='phoneNumber'
                        value={registerFields?.phoneNumber}
                        onChange={handleRegistrationInput}
                        pattern='\d{10}'
                        maxLength={10}
                        className='w-full p-2 border border-slate-300 text-[0.825em] outline-none'
                      />
                    </div>
                  </div>
                </div>

                <div className='md:flex w-full items-center md:gap-8 mb-3'>
                  <div className='mb-2 w-[50%]'>
                    <div className='w-full flex items-center justify-between mb-1'>
                      <p className='text-darkText text-[0.825em]'>State</p>
                      {fieldErrors?.profile?.state && (
                        <p className='text-red-700 text-[14px]'>
                          {fieldErrors?.profile?.state?.[0]}
                        </p>
                      )}
                    </div>
                    <select
                      className='bg-white border border-slate-300 text-[0.825em] outline-none p-2 w-[50%] '
                      value={registerFields?.state}
                      name='state'
                      onChange={handleRegistrationInput}
                    >
                      <option defaultValue=''>Choose State</option>
                      {states?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className='mb-5 w-[50%]'>
                    <div className='flex justify-between'>
                      <p className='text-[0.825em]'>Agree to receive mails</p>
                      
                      {fieldErrors?.profile?.receive_mails && (
                        <p className='text-red-700 text-[14px]'>
                          {Array.isArray(fieldErrors?.profile?.receive_mails)
                            ? fieldErrors.profile.receive_mails[0]
                            : fieldErrors?.profile?.receive_mails}
                        </p>
                      )}
                    </div>
                    <input
                      type='checkbox'
                      name='receiveEmail'
                      // value={registerFields?.receiveEmail ? true : false}
                      checked={registerFields?.receiveEmail}
                      onChange={handleRegistrationInput}
                      className='outline-none'
                    />
                  </div>
                </div>

                <img src={dottedLine} alt='Line' className='w-full mb-8' />

                <div className='md:flex items-center justify-between'>
                  <div>
                    {error && (
                      <p className='text-red-700 text-[14px]'>
                        {error.termAccepted}
                      </p>
                    )}
                    <div className='flex gap-2 mb-5'>
                      <input
                        type='checkbox'
                        name='termAccepted'
                        checked={registerFields?.termAccepted}
                        onChange={handleRegistrationInput}
                        className='outline-none'
                      />
                      <p className='text-darkText text-[0.825em]'>
                        I agree with{' '}
                        <Link
                          to={'/terms-and-conditions'}
                          onClick={() => setCurrentPage('terms')}
                          className='font-semibold text-darkGreen'
                        >
                          terms and conditions.
                        </Link>
                      </p>
                    </div>
                  </div>
                  <button
                    disabled={loading}
                    type='submit'
                    className='w-[120px] h-[48px] bg-darkGreen text-white'
                  >
                    {loading ? 'Submitting....' : 'Register'}
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className='hidden bg-slate-100 w-[40%] lg:flex justify-end p-0 pt-[85px] relative'>
            <div className='bg-slate-100 w-[545px] h-[800] absolute -top-4 bottom-0 left- -right-20 '></div>
            <img
              src={registerImg}
              alt='Register-Image'
              className='w-[700px] absolute bottom-0 -right-11'
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Register;
